function SEOSection() {
  return (
    <section className="py-10 bg-white rounded-xl shadow-sm border p-6">
      <h2 className="text-2xl font-semibold text-gray-900 mb-4">
        Find Food Based on Your Mood
      </h2>
      <div className="text-gray-600 space-y-3">
        <p>
          Sometimes you're hungry but have no idea what to eat.
        </p>
        <p>
          Mood Food Recommender helps you decide by starting with one simple question:
        </p>
        <p className="font-semibold text-gray-900">
          How do you feel right now?
        </p>
        <p>
          Different moods often lead to different food cravings. When you're stressed, you may want spicy food or comfort snacks. When you're tired, you may crave coffee or quick meals. When you're sad, warm and familiar foods may feel more comforting.
        </p>
        <p>
          Simply pick your mood and get food ideas instantly.
        </p>
      </div>
    </section>
  );
}

export default SEOSection;
